import styles from './container.module.scss';
import MaterialContainer from '@mui/material/Container';

/* eslint-disable-next-line */
export interface ContainerProps {
  // classes?: object,
  // component?: any,
  disableGutters?: boolean,
  fixed?: boolean,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  sx?: any,
  children?: any,
  className?: string,
  ['data-testid']?: string
}

export function Container(props: ContainerProps) {
  return (
    <MaterialContainer
      disableGutters={props.disableGutters}
      className={props.className}
      maxWidth={props.maxWidth}
      sx={props.sx}
      fixed={props.fixed}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialContainer>
  );
}

export default Container;